const STORAGE_KEY = 'viewedProductIds';
const MAX_ITEMS = 20;

export const VIEWED_PRODUCTS_EVENT = 'viewedProductsUpdated';

export const getViewedProductIds = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed)
      ? parsed.map((id) => Number(id)).filter((id) => id > 0)
      : [];
  } catch {
    return [];
  }
};

export const addViewedProduct = (productId) => {
  const id = Number(productId);
  if (!id) return;

  const ids = getViewedProductIds().filter((item) => item !== id);
  ids.unshift(id);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(ids.slice(0, MAX_ITEMS)));
  window.dispatchEvent(new Event(VIEWED_PRODUCTS_EVENT));
};
